<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">服务</div></div>
                <div class="title">应用开发</div>
                <div class="minTitle">能够为客户提供包括：系统开发、平台开发、APP开发、项目定制化开发等服务。为客户提升效率、降低成本，助力企业加速数字化转型。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       
       <picture>
            <source srcset="@/assets/images/yy1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/yy1.png" />
        </picture>
       <div class="yykf">
            <div class="content cont">
                <div class="title1 tc">「 深耕行业 性能卓越 」的应用开发服务</div>
                <div class="title2 mt15">舟恩拥有专业化的应用开发服务团队，长期为客户提供端到端的应用软件开发和维护服务。凭借在CMMI和ISO质量标准和流程认证基础上形成的规范，以及多年来丰富的项目实践经验，舟恩能够为客户提供包括：系统开发、平台开发、APP开发、项目定制化开发等服务。舟恩有成熟的开发交付模式，为客户提升效率、降低成本，助力企业加速数字化转型。</div>
            
                <div class="items mt15">
                    <div class="item2 bg1">
                        <div class="title4 myTitle oneTitle">行业覆盖</div>
                        <div class="minTitle2 mt10">舟恩提供金融、互联网、能源、汽车、房地产等行业的解决方案。</div>
                        <div class="title4 myTitle mt15">全生命周期</div>
                        <div class="minTitle2 mt10">涵盖需求调研、概要设计、详细设计、开发、测试以及部署实施全生命周期的软件开发服务。</div>
                        <div class="title4 myTitle mt15">定制化</div>
                        <div class="minTitle2 mt10">根据多年积累的各行业的IT经验，可以为客户提供专业化的定制化开发服务。</div>
                        <div class="title4 myTitle mt15">测试</div>
                        <div class="minTitle2 mt10">一支专业的测试团队，保障应用的可靠性</div>
                    </div>
                    <div class="item2 bg2">
                        <div class="title4 oneTitle minTitle2">拥有<span class="title4 myTitle2">项目管理认证(PMP)</span>的优秀项目管理人才</div>
                        <div class="title4 mt20 minTitle2">项目研发人员平均从业<span class="title4 myTitle2">经验超过5年</span></div>
                        <div class="title4 mt20 minTitle2">注重前沿技术的<span class="title4 myTitle2">研究与培训</span>，确保<span class="title4 myTitle2">人才的成长</span></div>
                    </div>
                    <div class="item2 item3 bg3">
                        <div class="title4 oneTitle minTitle2">基于<span class="title4 myTitle2">CMMI5级标准</span>的软件开发流程</div>
                        <div class="title4 mt20 minTitle2"><span class="title4 myTitle2">ISO9001</span></div>
                        <div class="title4 mt15 minTitle2"><span class="title4 myTitle2">ISO20000</span></div>
                        <div class="title4 mt15 minTitle2"><span class="title4 myTitle2">ISO27001</span>信息安全管理的管控体系</div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .yykf {
            background-color: #F5F7FA;
            .cont {
                padding: 30px 0;
                .title2 {
                    padding: 0 20px;
                    text-indent: 2em;
                    line-height: 20px;
                }

                .items {
                    display: flex;
                    flex-wrap: wrap;
                    .oneTitle {
                        margin-top: 110px;
                    }
                    .myTitle{
                        text-indent: 10px;
                        display: inline-block;
                        background: -webkit-linear-gradient(top, #FCD486, #ffffff);
                        background: -o-linear-gradient(top, #FCD486, #ffffff);
                        background: -moz-linear-gradient(top, #FCD486, #ffffff);
                        background: linear-gradient(to top,#FCD486, #ffffff);
                    }
                    .myTitle2{
                        display: inline-block;
                        background: -webkit-linear-gradient(top, #96F2F5, #ffffff);
                        background: -o-linear-gradient(top, #96F2F5, #ffffff);
                        background: -moz-linear-gradient(top, #96F2F5, #ffffff);
                        background: linear-gradient(to top,#96F2F5, #ffffff);
                    }
                    .item2 {
                        margin-top: 10px;
                        width: 27.33%;
                        background-color: #ffffff;
                        margin-right: 3%;
                        padding: 15px 2%;
                    }
                    .item3 {
                        margin-right: 0;
                        
                    }
                    .bg1 {
                        background: url(../../assets/images/yy2.png) no-repeat;
                    }
                    .bg2 {
                        background: url(../../assets/images/yy3.png) no-repeat;
                    }
                    .bg3 {
                        background: url(../../assets/images/yy4.png) no-repeat;
                    }
                    .bg1, .bg2, .bg3 {
                        min-height: 420px;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .yykf .cont .items {
        justify-content: space-between;
        .oneTitle {
            margin-top: 100px;
        }
        .item2 {
            width: 33.3%;
            margin-right: 0;
            min-height: 450px;
            box-sizing: border-box;
        }
    } 
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        .title {
          font-size: 20px;
        }
        .minTitle {
          width: 40%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    } 
    .yykf .cont .items {
        .item2 {
            width: 49%;
        }
        } 
  }
   }
   @media (max-width: 768px) {
     .index {
       .flash {
         padding: 0 15px;
         .minTitle {
           width: 50%;
           font-size: 13px;
         }
         .gg {
           top: 50px;
           .title {
             font-size: 20px;
           }
           .button {
             padding: 6px 15px;
             margin-top: 20px;
           }
         }
         
       }
       .flashImg {
         height: 40vh;
       } 
       .yykf .cont {
        .title1 {
            font-size: 20px;
        }
        .title2 {
            text-indent: 0;
            font-size: 14px;
        }
       }
       
       .yykf .cont .items {
            .item2 {
                width: 100%;
                padding: 15px 30px;
                min-height: 430px;
                background-size: 100% 115%;
                margin-bottom: 20px;
            }
            .minTitle2 {
                font-size: 14px;
            }
            .oneTitle {
                margin-top: 130px;
                text-indent: 0;
            }
            
        } 
     }
   }
</style>